"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressType = exports.AddressPurpose = void 0;
var AddressPurpose;
(function (AddressPurpose) {
    AddressPurpose["Ordinals"] = "ordinals";
    AddressPurpose["Payment"] = "payment";
    AddressPurpose["Stacks"] = "stacks";
})(AddressPurpose = exports.AddressPurpose || (exports.AddressPurpose = {}));
var AddressType;
(function (AddressType) {
    AddressType["p2pkh"] = "p2pkh";
    AddressType["p2sh"] = "p2sh";
    AddressType["p2wpkh"] = "p2wpkh";
    AddressType["p2wsh"] = "p2wsh";
    AddressType["p2tr"] = "p2tr";
    AddressType["stacks"] = "stacks";
})(AddressType = exports.AddressType || (exports.AddressType = {}));
//# sourceMappingURL=types.js.map